import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from 'vue';
import icons from '@/components/IllinoisSport/components/icons.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePageModal',
  props: {
  showPageParent: {
    type: Boolean,
    default: false
  },
  parentLoading: {
    type: Boolean,
    default: false
  },
  parentList: {
    type: Array as PropType<{ label: string; value: string }[]>,
    default: () => []
  },
  parentTitle: {
    type: String,
    default: ''
  },
  childLoading: {
    type: Boolean,
    default: false
  },
  childList: {
    type: Array as PropType<{ label: string; value: string }[]>,
    default: () => []
  },
  childSelected: {
    type: String,
    default: ''
  },
  childSelectedName: {
    type: String,
    default: ''
  },
  childSelectedId: {
    type: String,
    default: ''
  },
  urlBase: {
    type: String,
    default: ''
  }
},
  emits: ['close', 'show-parent', 'load-child'],
  setup(__props, { emit }) {

const props = __props;




const childTitle = ref(props.childSelectedName);

function selectParent(parentItem: { label: string; value: string }) {
  emit('load-child', parentItem.value);
  childTitle.value = parentItem.label;
}

return { __sfc: true,emit, props, childTitle, selectParent, icons }
}

})